import { render } from "./NewOutliersAnalysisModal.vue?vue&type=template&id=9afcdcde"
import script from "./NewOutliersAnalysisModal.vue?vue&type=script&lang=js"
export * from "./NewOutliersAnalysisModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__